import { render, staticRenderFns } from "./Aranceles.vue?vue&type=template&id=7aeff2f2&scoped=true"
import script from "./Aranceles.vue?vue&type=script&lang=js"
export * from "./Aranceles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeff2f2",
  null
  
)

export default component.exports